export default {"src":"https://s.sylndr.com/c-9cd064a/_next/static/media/table.f2918da7.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};